{
  "it": {
    "proposal": {
      "actions": {
        "addDescription": "Aggiungi descrizione",
        "addDocuments": "Aggiungi documenti",
        "addSubchoiceList": "Aggiungi elenco sotto-opzioni",
        "addSubchoices": "Aggiungi sotto-opzione",
        "approve": "Accetta",
        "cancel": "Annulla",
        "choice": {
          "collapse": "Comprimi opzioni",
          "delete": "Elimina opzione",
          "edit": "Modifica opzione",
          "expand": "Espandi opzioni"
        },
        "choice_list": {
          "delete": "Elimina elenco opzioni"
        },
        "createNew": "Nuova proposta",
        "deleteDescription": "Elimina descrizione",
        "deleteDocuments": "Rimuovi documenti",
        "delete_documents": "Elimina documento | Elimina documenti",
        "delete_proposal": "Elimina proposta",
        "delete_proposal_templates": "Elimina modello di proposta",
        "dontShare": "Non è ancora necessario condividere",
        "duplicate": "Duplica",
        "edit": "Modifica",
        "generatePDF": "Genera PDF",
        "new": "Proposta",
        "newProposalCustomer": "Nuova proposta",
        "publish": "Pubblica",
        "reject": "Annulla approvazione",
        "save": "Salva",
        "share": "Condividi",
        "shareWithProjectPartners": "Condividi documenti con i partner del progetto...",
        "share_units": "Condividi con le unità",
        "signAndApprove": "Firma e approva la proposta",
        "signElectronically": "Oppure firma elettronicamente",
        "steps": {
          "collapse": "Comprimi passaggi",
          "expand": "Espandi passaggi"
        },
        "stop_template_sync": "Interrompi sincronizzazione con il modello",
        "submit": "Salva",
        "uploadAndApprove": "Carica e approva la proposta",
        "uploadSignableDocument": "Carica documento firmato per l'approvazione"
      },
      "attributes": {
        "amount_gross": "Offerta lorda",
        "amount_net": "Offerta netta",
        "choice_lists": {
          "description": "Descrizione",
          "name": "Nome"
        },
        "choices": {
          "description": "Descrizione",
          "images": "Immagini",
          "name": "Nome",
          "price_gross": "Prezzo lordo articolo",
          "price_net": "Prezzo netto articolo",
          "quantity": "Quantità",
          "quantity_fixed": "Quantità fissa",
          "quantity_max": "Massimo",
          "quantity_min": "Minimo",
          "quantity_not_fixed": "Consenti al cliente di inserire la quantità",
          "selected_default": "Sempre selezionata",
          "total_price_gross": "Totale lordo",
          "total_price_net": "Totale netto"
        },
        "description": "Come descriverebbe questa proposta?",
        "documents": "Aggiungi documenti",
        "name": "Nome",
        "subtitle": "Rende più facile per gli altri farvi riferimento",
        "title": "Dia un titolo alla Sua proposta",
        "type": {
          "choices": "Elenco opzioni",
          "fixed": "Offerta fissa"
        },
        "vat_percentage": "% IVA"
      },
      "labels": {
        "accepted": "Accettata",
        "addExtraBudget": "Aggiungi budget extra",
        "allUnitsShared": "Questo modello è già condiviso con tutte le unità",
        "already_approved": "Questa proposta è già stata approvata.",
        "amount_net_total": "Offerta netta totale",
        "amount_total": "Offerta lorda totale",
        "approval_feedback": {
          "label": "Commento (facoltativo)",
          "placeholder": "Condivida domande, condizioni o contesto aggiuntivo con il team."
        },
        "approve": "Approva {name}",
        "approved": "Approvata",
        "approvedDate": "Approvata il {date}",
        "ask_client_to_undo": "Non può modificare una proposta approvata. Contatti {client} per annullare prima l'approvazione.",
        "batchProposalsTemplate": "<p>Questa proposta verrà creata per {units_count} unità.</p></br><p>Poiché questa proposta verrà creata per più unità, ne abbiamo ricavato un modello. Può trovare questo modello nella scheda \"Modelli di proposta\".</p></br><p>I modelli rendono più facile modificare o eliminare tutte le proposte condivise con questo modello.</p>",
        "batchProposalsWarning": "Questa proposta verrà creata per {units_count} unità. Se in seguito dovrà apportare modifiche, dovrà modificarle singolarmente.",
        "budget": "Budget",
        "builder": {
          "can_select_multiple": "Può selezionare più opzioni",
          "item": "Aggiungi opzione",
          "multiple_choices_possible": "Sono possibili più opzioni",
          "must_choose_item": "È necessario scegliere un'opzione",
          "options": "Opzioni",
          "section": "Elenco opzioni",
          "step": "Passaggio",
          "step_basic": "Informazioni di base",
          "step_details": "Dettagli",
          "step_documents": "Documenti",
          "step_internal": "Informazioni interne",
          "step_visibility": "Condividi con"
        },
        "by": "di",
        "choice_lists": {
          "add_another": "Aggiungi un altro elenco opzioni",
          "create": "Crea elenchi opzioni per la proposta",
          "empty_help": "Inizi aggiungendo il Suo primo elenco di opzioni. Gli elenchi di opzioni raggruppano le opzioni per un articolo specifico, ad esempio \"piastrelle per pavimento\". Dopo aver aggiunto gli elenchi di opzioni, potrà aggiungere una o più opzioni.",
          "selected": "Selezionato"
        },
        "choices": {
          "add_another": "Aggiungi un'altra opzione",
          "create": "Aggiungi opzioni a {choiceListName}",
          "optional": "facoltativo",
          "selected_default": "Questa opzione sarà sempre selezionata e il prezzo verrà calcolato automaticamente nel prezzo totale. Il cliente non potrà deselezionare questa opzione.",
          "selected_default_tooltip": "Questa opzione è sempre inclusa e il suo prezzo viene calcolato automaticamente nel totale.",
          "subtotal": "Subtotale"
        },
        "clickToChangeVisibility": "Faccia clic per modificare la visibilità",
        "closed": "Questa decisione è ora chiusa. Non può più approvare una proposta.",
        "createProposal": "Crea proposta",
        "createProposals": "Crea proposta",
        "created": "Creata",
        "createdBy": "Creata da {uploader}",
        "customer": "Cliente",
        "customerHasNotSelectedYet": "Il cliente non ha ancora selezionato",
        "customer_name_confirm": "Scriva <i><b>{customerName}</b></i> per accettare questa proposta.",
        "customer_name_proceed": "Digiti <i><b>{customerName}</b></i> per procedere.",
        "customer_offer": "Offerta cliente",
        "customers": "Clienti",
        "decision_not_interested": "La decisione è contrassegnata come non interessato.",
        "definedPerUnit": "Definito per unità",
        "delete_proposal_template": "<p>Se elimina questo modello, verranno eliminate anche tutte le proposte sincronizzate.<br>Se non desidera che ciò accada, utilizzi l'interruttore qui sotto.</p>",
        "depends_on_customer_input": "Dipende dall'input del cliente",
        "documentsRequireSignature": "Il cliente deve firmare i documenti",
        "documents_shared_partners": "Solo i documenti della proposta vengono condivisi con i partner del progetto.",
        "duplicating": "Duplicazione",
        "edit": "Modifica",
        "editNotAllowed": "Non è consentito modificare o eliminare una proposta approvata. Annulli prima l'approvazione per poter modificare.",
        "editProposal": "Modifica proposta",
        "excl%VAT": "IVA {vat}% esclusa",
        "exclVAT": "IVA esclusa",
        "export_documents": "Esporta documenti",
        "extraBudget": "Budget extra",
        "fractions_sent_count_header": "Impossibile creare la proposta",
        "fractions_sent_count_message": "Le rate basate su questa decisione sono già state inviate. Per continuare, imposti prima queste rate come bozza.",
        "full_prices": "Utilizzi i prezzi pieni. Ziggu genererà automaticamente le migliorie in base al budget della decisione",
        "generatingPDF": "Generazione PDF",
        "has_requested_changes": "Questa proposta ha già una richiesta di modifica in sospeso.",
        "hideDetails": "Nascondi dettagli",
        "installments_connected": "Ci sono rate collegate a questa proposta.",
        "internalNote": "Nota interna",
        "internalNoteSubtitle": "Questa nota è visibile solo a Lei e al Suo team.",
        "internal_info": "Informazioni interne",
        "keepHidden": "Mantieni nascosto",
        "keep_synced_proposals": "Mantenga le proposte sincronizzate in modo che diventino una proposta indipendente.",
        "link_to_template": "Collegare al modello?",
        "link_to_template_after_create": "Collega immediatamente questa proposta al nuovo modello dopo la creazione.",
        "makeDecision": "Accetti una proposta per {decision_name} facendo clic sul pulsante Approva",
        "margin": "Margine",
        "marginBudget%": "Margine budget ({margin}%)",
        "marginSurcharge%": "Margine migliorie ({margin}%)",
        "marginSurchargesExtraBudget%": "Margine budget extra + migliorie ({margin}%)",
        "new": "Nuova proposta",
        "noImage": "Nessuna immagine",
        "no_budget_available_yet": "Non applicabile",
        "no_documents": "La proposta non contiene documenti.",
        "no_edit_details": "Questa proposta ha elementi che dipendono da essa. Contatti il cliente se desidera modificarne i dettagli",
        "no_edit_details_installments": "Questa proposta ha almeno una rata fatturata o pagata. Per modificare i dettagli della proposta, deve prima cambiare lo stato di questa rata in \"Prevista\". Vada a {link}.",
        "no_edit_details_installments_link": "finanze",
        "no_edit_documents": "Quando una proposta è approvata, i documenti non possono essere modificati.",
        "notApplicable": "Non applicabile",
        "notDefined": "Non definito",
        "notSeenYetByCustomer": "Non ancora visualizzata dal cliente",
        "notSelectedYet": "Selezioni le Sue opzioni per vedere il totale",
        "notSharedYet": "Non ancora condivisa",
        "not_approved_yet": "Questa proposta non è ancora stata approvata.",
        "not_interested_reset_header": "Decisione contrassegnata come non interessato",
        "not_interested_reset_message": "Questa decisione è attualmente contrassegnata come \"Non interessato\". Creando una proposta, lo stato \"Non interessato\" verrà reimpostato.",
        "only_visible_team_partners": "Visibile solo al team",
        "other": "Altro",
        "proposalFor": "Proposta per",
        "proposal_template_sync_note": "Le modifiche a un modello di proposta aggiornano tutte le proposte sincronizzate (non approvate).",
        "proposal_unapprove_not_possible": "Impossibile annullare l'approvazione",
        "proposalsApproved": "Proposte approvate",
        "proposalsOther": "Altre proposte",
        "relaunch": "Rilancia proposta",
        "request_changes": {
          "body": "Fornisca ulteriori dettagli su cosa deve essere modificato in questa proposta",
          "feedback": "Feedback",
          "title": "Richiedi modifiche"
        },
        "requested_changes": "Modifiche richieste",
        "requiresSignature": "Deve firmare i documenti",
        "seenByCustomer": "Visualizzata dal cliente:",
        "selectUnitsShare": "Selezioni le unità con cui condividere il modello",
        "shareCustomerDescription": "Questa proposta è collegata a una decisione non ancora condivisa con il cliente. Desidera condividere anche la decisione, così il cliente potrà vedere subito questa proposta?",
        "shareCustomerTitle": "Condividere la decisione con il cliente?",
        "shareDecision": "Condividi decisione",
        "shareExtraAlert": "La decisione verrà condivisa anche facendo clic su invia",
        "sharePartnerTitle": "Condividere la decisione con il partner?",
        "sharePartnersDescription": "Questa proposta è collegata a una decisione non ancora condivisa con il partner. Desidera condividere anche la decisione, così il partner potrà vedere subito questa proposta?",
        "sharedWith": "Condiviso con",
        "showAndEditDetails": "Mostra e modifica dettagli",
        "single_approval_warning": {
          "message": "Contatti Ziggu per abilitare l'approvazione di più proposte.",
          "title": "Può continuare a creare proposte, ma il cliente potrà approvarne solo una."
        },
        "skip_customer": "Il progetto salta il passaggio del cliente.",
        "surcharges": "Migliorie",
        "surcharges_extra": "Migliorie extra",
        "synced_with_template": "Sincronizzata con il modello di proposta",
        "synced_with_units": "Sincronizzata con 1 unità | Sincronizzata con {unit_count} unità",
        "template_accept_confirm": "<p>Questa proposta è sincronizzata con un modello di proposta. Quando accetta questa proposta, la sincronizzazione si interrompe e la proposta non verrà più aggiornata quando il modello viene aggiornato.</p></br><p>È sicuro di voler accettare questa proposta?</p>",
        "template_edit_confirm": "<p>Questa proposta è sincronizzata con un modello di proposta. Quando modifica questa proposta, la sincronizzazione si interrompe e la proposta non verrà più aggiornata quando il modello viene aggiornato.</p></br><p>È sicuro di voler continuare a modificare questa proposta?</p>",
        "totalBudget": "Budget totale",
        "totalNetOffer": "Offerta netta",
        "total_excl_vat": "Totale IVA esclusa",
        "total_incl_vat": "Totale IVA inclusa",
        "total_vat": "IVA totale",
        "typeToShare": "Tipo di proposta da condividere",
        "unit_not_activated": "L'unità non è attivata.",
        "uploadDocuments": "Carica documenti firmati",
        "uploadSignedDocument": "Oppure carica il documento firmato",
        "vat_excl": "IVA esclusa",
        "vat_excl_with_number": "IVA {vat}% esclusa",
        "visibleForCustomer": "Visibile per il cliente",
        "writeEmployeeNameAccept": "Scriva <i><b>{employeeName}</b></i> per accettare questa proposta.",
        "writeEmployeeNameDelete": "Scriva <i><b>{employeeName}</b></i> per rimuovere questa proposta.",
        "writeEmployeeNameReject": "Scriva <i><b>{employeeName}</b></i> per annullare l'approvazione di questa proposta."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Presto troverà qui una proposta da approvare",
            "title": "Nessuna proposta ancora per la decisione {decision_name}"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Proponga una o più offerte e lasci decidere il Suo cliente.",
            "title": "Crea una proposta"
          },
          "proposalNotice": "Importante: può essere approvata solo 1 proposta. Può sempre modificare una proposta esistente e aggiungere nuovi documenti.",
          "template": {
            "subtitle": "Quando crea proposte in blocco, compariranno qui",
            "title": "Nessun modello di proposta ancora creato."
          }
        },
        "partners": {
          "new": {
            "subtitle": "Proponga una o più offerte e lasci decidere il cliente.",
            "title": "Crea una proposta"
          },
          "proposalNotice": "Importante: può essere approvata solo 1 proposta. Può sempre modificare una proposta esistente e aggiungere nuovi documenti. Se una proposta è già stata approvata, un membro del team può annullarla prima di aggiungere documenti extra."
        }
      },
      "toasts": {
        "convert": "Proposta convertita in modello con successo",
        "create": "Proposta creata con successo",
        "delete": "Proposta eliminata con successo",
        "shareSuccess": "Proposte condivise con successo",
        "update": "Proposta aggiornata con successo"
      },
      "validation": {
        "amountNotUpdatable": "L'importo non può essere aggiornato: alcune rate dipendono da esso",
        "choice_list": {
          "needChoice": "Questo elenco di opzioni necessita di almeno 1 opzione",
          "needSelection": "Questa opzione richiede un elemento selezionato"
        },
        "choices": {
          "lessThanOrEqual": "Il numero deve essere minore o uguale a {max_number}",
          "needPriceItem": "Il prezzo per articolo è obbligatorio",
          "needSelection": "Selezione dell'opzione obbligatoria",
          "needVatPercentage": "La percentuale IVA è obbligatoria",
          "quantityBetween": "La quantità deve essere compresa tra {quantity_min} e {quantity_max}",
          "quantityNotZero": "La quantità deve essere almeno 1",
          "quantityRequired": "La quantità è obbligatoria",
          "uniqueNames": "I nomi devono essere univoci"
        },
        "nameAlreadyTaken": "Il titolo è già utilizzato per questo progetto",
        "nameNotCorrect": "Il nome è obbligatorio e deve corrispondere",
        "needName": "Titolo obbligatorio",
        "needNumber": "Deve essere un numero (es. 85)",
        "need_request_changes_note": "Fornisca dettagli sulla Sua richiesta di modifica",
        "readAllDocuments": "Confermi di aver letto tutti i documenti",
        "requiresSignature": "Contrassegni almeno 1 documento in cui il cliente deve firmare elettronicamente. Disattivi l'interruttore sottostante se non necessita di firme.",
        "share": {
          "needSelection": "Selezioni qualcuno con cui condividere la proposta | Selezioni qualcuno con cui condividere le proposte",
          "needType": "Selezioni il/i tipo/i di proposta"
        },
        "uploadAtLeast1Document": "Carichi almeno 1 documento firmato"
      }
    }
  }
}
